export interface StatKey {
    id: string;
    index: number;
    name: string;
    named_code: string;
    label: { original: string; i18nLabel: string };
    value: number | string;
    shortValue: number | string;
    fullValue: number | string;
    subValue?: SubValue;
    additionalValue?: SubValue & { shortValue?: string; fullValue?: string };
    diffValue?: SubValue & { fullValue?: string };
    tooltipValue?: {
        value: number;
    };
    charts: Array<ChartCommonConfig>;
    format: STAT_VALUE_FORMAT;
    job_group_entity_ids?: Array<string>;
}

export interface StatNamedCalculation {
    name: string;
    i18nStatName: string;
    named_code: string;
    named_calculation_entity_id?: string;
    type: string;
    job_group_entity_ids?: Array<string>;
    comparison_default?: boolean;
}

export interface ChartCommonConfig {
    id: string;
    named_code?: string;
    title: {
        original: string;
        sourceTag?: string;
        i18nTitle: string | null;
        i18nSourceTag?: string;
    };
    xKeys?: Array<string>;
    yKeys?: Array<string>;
    yNames?: Array<{
        original: string;
        sourceTag?: string;
        i18nYName: string | null;
        i18nAppendixTag?: string;
        named_code?: string;
    }>;
    yFormat?: string;
    xLeftAxesTitle?: {
        original: string;
        i18nTitle: string | null;
    };
    yBottomAxesTitle?: {
        original: string;
        i18nSourceTag: string;
    };
    sourcePath?: string;
    extendedChartOptions?: any;
}

export interface SubValue {
    value: number | string;
    originalValue?: number;
    label: string;
    i18nLabel?: string;
    format: STAT_VALUE_FORMAT;
    precision: number;
}

export enum DEFAULT_STAT_VALUE_FORMAT {
    DECIMAL = 'decimal',
    FLOAT = 'float',
    CURRENCY = 'currency',
    PERCENT = 'percent',
}

export enum STAT_VALUE_FORMAT_EXTENSION {
    NUMBER = 'number',
    AMOUNT = 'amount',
}

export type STAT_VALUE_FORMAT = DEFAULT_STAT_VALUE_FORMAT | STAT_VALUE_FORMAT_EXTENSION;
export const STAT_VALUE_FORMAT = { ...DEFAULT_STAT_VALUE_FORMAT, ...STAT_VALUE_FORMAT_EXTENSION };
